import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTreasure({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<mask
					id="a"
					width={20.98}
					height={19.1}
					x={1.51}
					y={2.63}
					maskUnits="userSpaceOnUse"
				>
					<path
						fill="#fff"
						fillRule="evenodd"
						strokeWidth={0}
						d="M1.51 2.63h20.97v19.11H1.51z"
					/>
				</mask>
			</defs>
			<g mask="url(#a)">
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M2.27 9c-.08-.69.11-1.37.54-1.92s1.05-.89 1.74-.97 1.37.11 1.92.54l1.47 1.16s.11.06.16.07l-3.18 4.18-1.67-1.32c-.55-.43-.89-1.05-.97-1.74Zm9 4.81L6.54 12.5l9.25-2.28 5 1.39-9.52 2.21ZM17.14 15c0 .61-.52 1.25-1.14 1.4-.28.06-.53.02-.71-.12-.17-.14-.26-.35-.26-.61v-1.83s-.01-.08-.02-.12l2.14-.5V15ZM8.9 8.07l9.09-2.3-2.53 3.68s-.03.06-.04.09l-9.41 2.32zm-1.97-2c-.2-.16-.42-.29-.65-.4l9.71-2.27 2.03 1.58-9.43 2.39s-.03.01-.04.02c-.01 0-.02 0-.03.01a.36.36 0 0 0-.12-.18L6.93 6.06Zm.94 13.51-2.22-6.55 5.24 1.45-.03 6.32-2.99-1.23Zm11.45-.75-7.72 2.04.03-6.38 2.64-.61v1.78c0 .49.19.92.55 1.2.26.21.59.31.94.31.13 0 .27-.02.4-.05.96-.22 1.72-1.16 1.72-2.12v-1.96l3.68-.85-2.23 6.64Zm3.16-7.13v-.11c0-.01-.01-.02-.02-.04 0-.02-.02-.05-.03-.07s-.03-.04-.04-.05l-.05-.05-.02-.02a.42.42 0 0 0-.23-.18l-5.81-1.61 2.89-4.2v-.01l.03-.06c0-.02.02-.03.02-.05v-.17c0-.02-.01-.03-.02-.04 0-.02-.01-.04-.02-.06 0 0 0-.01-.02-.02-.01-.02-.03-.03-.04-.05-.01-.01-.02-.03-.03-.03l-2.78-2.16h-.02c-.02-.02-.05-.03-.08-.04-.02 0-.04-.02-.06-.02h-.17L3.93 5.45c-.06.01-.1.04-.15.07-.61.2-1.15.58-1.55 1.1-.55.7-.8 1.58-.7 2.47s.55 1.68 1.25 2.24l2.05 1.62 2.38 7.03v.01c0 .01.01.02.02.04.01.03.03.05.05.08 0 .01.02.02.03.03.02.02.05.04.08.05l.02.02 3.65 1.5h.01c.04.01.08.02.12.02.03 0 .06 0 .09-.01l8.38-2.22q.06-.015.12-.06l.02-.02c.02-.02.05-.05.06-.07 0-.01.01-.03.02-.04 0-.01.02-.03.02-.04l2.5-7.46v-.1Z"
				/>
			</g>
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M12.63 5.99c.07.07.16.1.26.1s.2-.04.27-.12c.14-.15.14-.39-.01-.53l-.71-.68a.377.377 0 0 0-.53.01c-.14.15-.14.39.01.53l.71.68Z"
			/>
			<path
				fill="#cd0400"
				fillRule="evenodd"
				d="M16.08 14.51a.29.29 0 0 0-.29.29v.59a.29.29 0 0 0 .58 0v-.59a.29.29 0 0 0-.29-.29m-2.54-2.16c-1.36-.37-1.91.49-1.93.52a.3.3 0 0 0 .09.4c.05.03.1.05.16.05.1 0 .19-.05.25-.13.01-.02.36-.52 1.28-.27.16.04.32-.05.36-.21a.29.29 0 0 0-.21-.36m-2.48-.34c-1.36-.37-1.91.49-1.93.52-.08.14-.04.32.09.4a.297.297 0 0 0 .4-.1s.34-.52 1.28-.27c.15.04.32-.05.36-.21a.29.29 0 0 0-.21-.36m4.47-1.07c-1.36-.37-1.91.49-1.93.52a.3.3 0 0 0 .09.4c.05.03.1.05.16.05.1 0 .19-.05.25-.13.01-.02.36-.52 1.28-.27.15.04.32-.05.36-.21a.29.29 0 0 0-.21-.36m2.51.33c-1.36-.37-1.91.49-1.93.52a.3.3 0 0 0 .09.4c.05.03.1.05.16.05.1 0 .19-.05.25-.13.01-.02.36-.52 1.28-.27.16.04.32-.05.36-.21a.29.29 0 0 0-.21-.36"
			/>
		</svg>
	);
}
